module.exports = __webpack_public_path__ + "static/media/Dec404.catalyst.8c7d4788.tsx";